import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createByRoleReducer from './byRole'
import createByBadgeReducer from './byBadge'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

export default combineReducers({
  byId: createByIdReducer('adminUser'),
  allIds: createAllIdsReducer('adminUser'),
  indexIds: createIndexIdsReducer('adminUser'),
  byRole: createByRoleReducer('adminUser'),
  byBadge: createByBadgeReducer('adminUser'),
  meta: createMetaReducer('adminUser'),
})

// SELECTORS

export const selectAdminUserList = (state) => {
  return state.allIds.map((id) => state.byId[id]) || []
}

export const selectAdminUserIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectAdminUserMeta = (state) => {
  return state.meta || {}
}

export const selectAdmin = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}
